/**
*@title 일정 안내
*@date 2022-02-09
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
import Slider from "react-slick";
import { t } from 'i18next';

import SymposiumSpeaker0 from './SymposiumSpeaker_day0';
import SymposiumSpeaker1 from './SymposiumSpeaker_day1';

import SymposiumAgingSpeakerCards from '../../Components/SymposiumSpeakerCard/SymposiumAgingSpeakerCards';
import SymposiumGeneralSpeakerCards from "../../Components/SymposiumSpeakerCard/SymposiumGeneralSpeakerCards";

import "../../Components/Slider/slick.css";
import "../../Components/Slider/slick-sympospeaker-theme.css";


const SymposiumSpeaker = () => {
    /*const settings = {
        arrows:true,
        dots: false,
        infinite: true,
        speed: 300,
        // centerMode : true,
        // nextArrow: <ArrowRight />,
        // prevArrow: <ArrowLeft />,
        slidesToShow:1,
        slidesToScroll:1
    };*/
    
    return(
        <div className="sect-01-box-01-gallery">
            <div className="sect-01-box-01-seminar">
                <div className="sect-03-tit-01 sect-tit">{t("symposium_speaker_title")}</div>

                    <div className='symposium-speaker-tbl-wrap'>
                        <div class="title">
                            {t("symposium_speaker_day0_title")}
                        </div>
                        <SymposiumAgingSpeakerCards />
                        {/*<div class="table">
                            <SymposiumAgingSpeakerCards />
    </div>*/}
                    </div>
                    <div className='symposium-speaker-tbl-wrap'>
                        <div class="title">
                            {t("symposium_speaker_day1_title")}
                        </div>
                        <SymposiumGeneralSpeakerCards />
                        {/*<div class="table">
                            <SymposiumSpeaker1/>
</div>*/}
                    </div>
            </div>
        </div>
    )
}

export default SymposiumSpeaker;